import React, { useMemo, useState } from 'react';
import { DatabaseZap, Cpu, Archive } from 'lucide-react';
import DataStores from '../DataStores';
import Cache from './Cache';
import DataVaults from './DataVaults';

type TabId = 'vector-store' | 'cache' | 'data-vault';

const DataVaultRouting: React.FC = () => {
  const [tab, setTab] = useState<TabId>('vector-store');

  const tabs = useMemo(
    () => ([
      { id: 'vector-store' as const, label: 'Vector Store', Icon: DatabaseZap },
      { id: 'cache' as const, label: 'Cache', Icon: Cpu },
      { id: 'data-vault' as const, label: 'Data Vault', Icon: Archive },
    ]),
    []
  );

  return (
    <div className="flex min-h-screen gap-8">
      <aside className="w-64 flex-shrink-0 border-r border-neutral-800 flex flex-col">
        <div className="p-4 flex items-center justify-between border-b border-neutral-800">
          <h2 className="text-white font-semibold text-sm">Data Vault</h2>
        </div>
        <nav className="flex-1 overflow-y-auto px-2 py-4 space-y-2" aria-label="Configuration type">
          {tabs.map((t) => {
            const isActive = tab === t.id;
            const Icon = t.Icon;
            return (
              <div
                key={t.id}
                className="group flex items-center justify-between px-3 py-2 rounded-md hover:bg-neutral-800 transition"
              >
                <button
                  type="button"
                  onClick={() => setTab(t.id)}
                  className={`flex items-center w-full text-left truncate ${isActive ? 'text-white' : 'text-gray-300'}`}
                  aria-current={isActive ? 'page' : undefined}
                >
                  <Icon size={16} className="mr-2 flex-shrink-0" />
                  <span className="truncate">{t.label}</span>
                </button>
              </div>
            );
          })}
        </nav>
      </aside>

      <main className="flex-1 min-w-0">
        {tab === 'vector-store' && <DataStores />}
        {tab === 'cache' && <Cache />}
        {tab === 'data-vault' && <DataVaults />}
      </main>
    </div>
  );
};

export default DataVaultRouting;
